export const COLUMN_NAME = {
  DATE: "Date",
  PRODUCT: "Product",
  EXPORTER: "Exporter",
  IMPORTER: "Importer",
  COUNTRY_OF_ARRIVAL: "Country of Arrival",
  LEAVES_COUNTRY_OF_ORIGIN: "Leaves - Country of Origin",
};
